if (!customElements.get('maison-tally-form')) {
  customElements.define('maison-tally-form', class extends HTMLElement {
    connectedCallback() {
      if (window.Tally) {
        window.Tally.loadEmbeds();
        return;
      }
      let script = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');
      if (!script) {
        script = document.createElement('script');
        script.src = 'https://tally.so/widgets/embed.js';
        script.async = true;
        document.head.append(script);
      }
      this.script = script;
      this.onLoad = () => { if (this.isConnected) window.Tally?.loadEmbeds(); };
      script.addEventListener('load', this.onLoad, { once: true });
    }
    disconnectedCallback() {
      this.script?.removeEventListener('load', this.onLoad);
    }
  });
}
